import api from '../api'
import {
  PaymentEntry,
  ShiftEntry,
  WorkItemEntry,
} from 'components/CommandPalette/CommandPalette_Utils'

type FastIdSearchPaymentResponse = {
  id: number
  status: string
  amount: string
  type: 'payment'
}

type FastIdSearchShiftResponse = {
  id: number
  startsAt: string
  type: 'shift'
}

type FastIdSearchWorkItemResponse = {
  id: number
  workerId: number
  shiftId: number
  status: string
  startedAt?: string
  completedAt?: string
  type: 'work'
}

type FastIdSearchResponse = {
  payments: FastIdSearchPaymentResponse[]
  shifts: FastIdSearchShiftResponse[]
  workItems: FastIdSearchWorkItemResponse[]
}

export type FastIdSearchResult = {
  payments: PaymentEntry[]
  shifts: ShiftEntry[]
  workItems: WorkItemEntry[]
}

export const fastIdSearch = async (
  search: string,
  limit = 3
): Promise<FastIdSearchResult> => {
  const response = await api.get<FastIdSearchResponse>(
    '/admin/fast_id_search',
    {
      params: {
        search: search.trim(),
        limit,
      },
    }
  )

  return {
    payments: response.data.payments.map(
      (item): PaymentEntry => ({
        id: item.id,
        status: item.status,
        amount: parseFloat(item.amount),
        historyType: 'payments',
      })
    ),
    shifts: response.data.shifts.map(
      (item): ShiftEntry => ({
        id: item.id,
        startsAt: item.startsAt,
        historyType: 'shifts',
      })
    ),
    workItems: response.data.workItems.map(
      (item): WorkItemEntry => ({
        id: item.id,
        workerId: item.workerId,
        shiftId: item.shiftId,
        status: item.status,
        startedAt: item.startedAt,
        completedAt: item.completedAt,
        historyType: 'work_items',
      })
    ),
  }
}
